// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"JobMatchVideoDialog_dialogContent__0X0Ji","description":"JobMatchVideoDialog_description__CFIRE","videoContainer":"JobMatchVideoDialog_videoContainer__mIomd"};